import UI from '../../components/ExcerciseTypes/Design/UserInterface'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import D1 from '../../components/ExcerciseTypes/Design/TypeIn'

const json = {
	1: {
		// Exercise num
		unit: 'Stater',
		id: '4WB-S-P6-E1',
		audio: 'Audios/Track 01.mp3',
		exerciseKey: 'img/FriendsPlus/Page6/E1/Key/E1answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		component: T6,
		inputSize: 108,
		textAlign: 'center',
		maxLength: 8,
		// isHiddenCheck: true,
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 20,
			height: 22,
			width: 35,
		},
		isHiddenCheck: true,
		titleQuestion: [
			{
				num: '1',
				title:
					"Read the text in the Student Book. Write. <headphone name='01' src='Audios/Track 01.mp3'></headphone>",
				color: '#234090',
			},
		],

		questions: [
			{
				title: `
        <div style=" position: relative; padding-top:20px ">
						<div> <img style='width:25cm' src='img/FriendsPlus/Page6/E1/1.jpg' /> </div>
            
            <div style=" position: absolute; top:179px; left: 370px; "><input id='0' font-size='23px'  border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 185px; left: 636px; "><input id='1' font-size='23px'  border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 202px; left: 893px; "><input id='2' font-size='23px'  border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 286px; left: 240px; "><input id='3' font-size='23px'  border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 277px; left: 500px; "><input id='4' font-size='23px'  border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 282px; left: 768px; "><input id='4' font-size='23px'  border-bottom='0px'></input></div>
				</div>
          `,
				answer: ['5', '6', '4', '3', '2', '7'],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Stater',
		id: '4WB-S-P6-E2',
		audio: '',
		hideBtnFooter: true,
		exerciseKey: 'img/FriendsPlus/Page7/Key/E1answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		component: T6,
		inputSize: 250,
		textAlign: 'center',
		maxLength: 18,

		titleQuestion: [
			{
				num: '2',
				title: 'Find and circle the days of the week. Write.',
				color: '#234090',
			},
		],
		hintBox: [
			{
				src: [
					'Sunday',
					'Monday',
					"<s style='color:gray'>Tuesday</s>",
					'Wednesday',
					'Thursday',
					'Friday',
					'Saturday',
				],
				width: 1000,
				borderColor: 'rgb(133,208,151)',
			},
		],
		questions: [
			{
				title: `
        <hintbox id='0' style='border-radius:1px'></hintbox>		
        <div style="align-items: flex-end; position: relative; padding-top:20px; display:flex "> 
            <div> <img style='width:15cm; margin-right:20px' src='img/FriendsPlus/Page6/E2/1.jpg' /> </div>
            <div>Today is &ensp;#&ensp;.</div>
				</div>
          `,
				answer: [''],
			},
		],
	},
	3: {
		// Exercise num
		unit: 'Stater',
		id: '4WB-S-P6-E3',
		audio: '',
		exerciseKey: 'img/FriendsPlus/Page6/E3/Key/E3answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		component: T6,
		inputSize: 45,
		textAlign: 'center',
		textTransform: 'uppercase',
		bgColor: 'none',
		maxLength: 8,
		// isHiddenCheck: true,
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 20,
			height: 22,
			width: 35,
		},
		isHiddenCheck: true,
		titleQuestion: [
			{
				num: '3',
				title: 'Write.',
				color: '#234090',
			},
		],
		questions: [
			{
				title: `
        <div style=" position: relative; padding-top:20px ">
	          <div> <img style='width:25cm'src='img/FriendsPlus/Page6/E3/1.jpg' /> </div>
            <div style=" position: absolute; top:266px; left: 265px; "><input id='0' font-size='22px' border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 266px; left: 326px; "><input id='1' font-size='22px' border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 266px; left: 674px; "><input id='2' font-size='22px' border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 266px; left: 732px; "><input id='3' font-size='22px' border-bottom='0px'></input></div>
            <div style=" position: absolute; top: 266px; left: 772px; "><input id='4' font-size='22px' border-bottom='0px'></input></div>
				</div>

          `,
				answer: ['N', 'S', 'A', 'U', 'R'],
			},
		],
	},
}

export default json
